const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessAddAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.351,
    height: 110,
    viewBox: "0 0 201.351 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6460"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4827",
    transform: "translate(.351)",
    style: {
      fill: "none"
    },
    d: "M0 0h200v110H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5771",
    transform: "translate(.001 4.14)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5761"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21834",
    d: "M13.3 105.86C12 104.42-5.64 83.91 1.84 65.47c9.73-24 37.64-28.92 55.3-17.55 4.21 2.71 12.41 12.45 20.4 12.57 14.09.2 39.55-50.83 71.49-50.67 21.21.11 39.68 20.06 40 40.88.28 15.51-13.69 24.19-9.06 36.5 3.26 8.66 13 15.63 20.9 18z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4828",
    transform: "translate(12.01 105.06)",
    style: {
      fill: "#d3d7df"
    },
    d: "M0 0h189.34v.79H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5766"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21835",
    d: "m105.81 93.63 14.79-25.22-16.76-63.6a6.23 6.23 0 0 0-7.6-4.44l-51 13.27a6.23 6.23 0 0 0-4.46 7.6L61 98.85a6.23 6.23 0 0 0 7.6 4.46z",
    style: {
      fill: "#cdd0da"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5762"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2553",
    cx: 8.18,
    cy: 8.18,
    r: 8.18,
    transform: "translate(51.21 23.78)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21836",
    d: "M66.4 36.18a12.809 12.809 0 0 0-.56-1.53 3.24 3.24 0 0 1-.37-1.48 5 5 0 0 0-1.68-.06c-1.14.1-5.48.33-5.74.32a8.2 8.2 0 0 0-1.51.82l-2.4.82s1 3 1.28 4a8.2 8.2 0 0 0 11-2.93z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21837",
    d: "M59.28 26.07a2.457 2.457 0 0 0-.75.18l-.56.13a1.9 1.9 0 0 0-.94 1 2.92 2.92 0 0 0-.24 1.44 4.51 4.51 0 0 0 .46 1.87l-.35.09-.62-2.43a2.48 2.48 0 0 1 .22-1.14c.32-.7 1-1.11.89-1.21s-.37.11-.37.09a2.81 2.81 0 0 1 1.59-.78 3.32 3.32 0 0 1 2.56.76 3.41 3.41 0 0 1 .7.76 1.34 1.34 0 0 1 .19.44l.54 2.22-.36.08a21.519 21.519 0 0 1-.56-2.24c0-.07-.24.23-.26.16a2.19 2.19 0 0 0-2.14-1.42z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21838",
    d: "M61.74 29.63a1 1 0 0 1 .65-.56.715.715 0 0 1 .42.1c.11.1-.09.37 0 .79 0 .19.1.22.09.37a.61.61 0 0 1-.28.47.72.72 0 0 1-.84-.19.93.93 0 0 1-.04-.98z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21839",
    d: "M57.5 31.35c.07.59.13 1.11.18 1.55a2.9 2.9 0 0 1-.09 1.21 2.29 2.29 0 0 0 .36 1.5A3.28 3.28 0 0 0 60.27 37a2.12 2.12 0 0 0 1.36-.13c.92-.52 1.1-2 1.23-3.08v-.6l-1-4.27z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21840",
    d: "M62.86 33.81v-.55a16.82 16.82 0 0 0-.76-3.19l-.24-1c-.41 0-1 3.75-1.33 5.08a2 2 0 0 1-.24.66c-.1.14-.15.16-.14.23a4.218 4.218 0 0 1 1.12.52 1.17 1.17 0 0 1 .27.33 1.23 1.23 0 0 1 .09 1c.93-.58 1.1-2.01 1.23-3.08z",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21841",
    d: "M57.41 26.52a2.75 2.75 0 0 0-.76 1.77 7.11 7.11 0 0 0 .23 1.71c.32 1.69.49 2 .62 2.13a2.62 2.62 0 0 0 1.2.89 2.72 2.72 0 0 0 2.15-.13 2.8 2.8 0 0 0 1.37-1.72 5.62 5.62 0 0 0-.13-2.14 5.28 5.28 0 0 0-.41-1.69A3.15 3.15 0 0 0 60 26a2.85 2.85 0 0 0-2.59.52z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21842",
    d: "M62.22 31.19a5 5 0 0 0-.1-1.94c0 .19.25 1.81-.56 2.5a1.9 1.9 0 0 1-.7.37c-.45.11-.61-.07-1 0s-.46.5-.85.6c-.61.17-1.25-.54-1.3-.47s.06.15.21.31a2.58 2.58 0 0 0 .76.44 2.72 2.72 0 0 0 2.15-.13 2.8 2.8 0 0 0 1.39-1.68z",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21843",
    d: "M57.16 30.35c-.13-.15-.35-.34-.47-.28s-.08.29 0 .6a1.66 1.66 0 0 0 .18.75c.1.17.36.52.51.47a1.535 1.535 0 0 0-.22-1.54z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21844",
    d: "m67.37 33.78-.29-.11a5.31 5.31 0 0 0-1.91-.52c-.64.33 0 2.38.69 3.81a8.27 8.27 0 0 0 1.51-3.18z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21845",
    d: "m67.37 33.78-.29-.11a5.31 5.31 0 0 0-1.91-.52c-.64.33 0 2.38.69 3.81a8.27 8.27 0 0 0 1.51-3.18z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21846",
    d: "M54.14 35.05c-.19 0-.42.41-.89 1.21-.15.24-.27.45-.38.64a8.17 8.17 0 0 0 3.25 2.55c-.12-2.31-1.24-4.45-1.98-4.4z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21847",
    d: "M54.14 35.05c-.19 0-.42.41-.89 1.21-.15.24-.27.45-.38.64a8.17 8.17 0 0 0 3.25 2.55c-.12-2.31-1.24-4.45-1.98-4.4z",
    style: {
      fill: "#88909f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5763"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2554",
    cx: 8.18,
    cy: 8.18,
    r: 8.18,
    transform: "translate(57.07 47.88)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21848",
    d: "M70.94 58.44c-1.56.59-2.08.07-2.6.64s-.15 1.12-.72 1.55a1.57 1.57 0 0 1-1 .26c-1-.1-1.23-.53-1.94-1.18-.31-.28-.38.13-2 .76-.89.35-.13 2.47.37 3.46a8.2 8.2 0 0 0 8.8-3c-.28-1.29-.63-2.59-.91-2.49z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21849",
    d: "M64.33 56.2c-.23.55.55 1 .57 2.34a4.49 4.49 0 0 0 0 1.1 2.43 2.43 0 0 0 .9 1.44c.15.11 1 .76 1.75.4a1.81 1.81 0 0 0 .59-2.08c-.18-.59-.52-.55-.83-1.17-.54-1.09.15-1.88-.31-2.41a2 2 0 0 0-2.67.38z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21850",
    d: "M67 55.82a2 2 0 0 0-2.67.38c-.21.51.44.92.56 2a5.06 5.06 0 0 0 1 0 3.82 3.82 0 0 0 1.31-.2c-.33-1 .22-1.69-.2-2.18z",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21851",
    d: "M63.45 62.75c.4-.7.74-1.25 1-1.62a5.75 5.75 0 0 0 .4-.64 4.34 4.34 0 0 0 .44-1.49A5.6 5.6 0 0 0 63 55.41a1.2 1.2 0 0 1-.52-1s.3 1.59.97 8.34z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21852",
    d: "M71.85 58.77c-.51-.73-.9-.49-1.68-1.24-1.11-1.06-.88-2.09-1.68-2.35a1.64 1.64 0 0 0-1.75.71c-.41.69.3 1.15.88 3.64.26 1.08.27 1.6.77 2s.82.27 1.3.78a3 3 0 0 1 .31.4 8.25 8.25 0 0 0 2.35-2.61 3 3 0 0 0-.5-1.33z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21853",
    d: "M62.66 52.75a2.85 2.85 0 0 0 0 1.1 5.79 5.79 0 0 0 .19.78c.28 1.07.19 1 .31 1.3a3.67 3.67 0 0 0 1.1 1.07c.6.5.91.74 1.3.79a1.52 1.52 0 0 0 1-.26 1.68 1.68 0 0 0 .59-1 6.39 6.39 0 0 0 .08-3.05c-.28-1-.53-2-1.42-2.41a2.36 2.36 0 0 0-2.4.31 2.41 2.41 0 0 0-.75 1.37z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21854",
    d: "M69.39 56.62a24.819 24.819 0 0 0-1.47-3.78c-.78-1.57-1.18-2.37-2.06-2.8s-2.42-.48-2.73.11a1.32 1.32 0 0 0 .64 1.5c.62.34 1.14-.19 1.69.14.35.21.31.52.7 1.76s.61 1.85 1.1 2.21.87.13 1.23.53.13 1.06.31 2.4a5.34 5.34 0 0 0 .38 1.56A4.25 4.25 0 0 0 70.86 62a7.761 7.761 0 0 0 .73-.79c-.48-.79-.72-.85-1.17-1.56a10.31 10.31 0 0 1-1.03-3.03z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21855",
    d: "M73 58.82a1.54 1.54 0 0 0-1.29-.28l-.91.23.65 2.68A8 8 0 0 0 73 58.82z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21856",
    d: "m60.81 62.13-.23.65a8.15 8.15 0 0 0 3 1.3l-.37-3.6-.84.21a2.27 2.27 0 0 0-1.56 1.44z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21857",
    d: "M63.13 50.15c-.58.05-1.38 1.68-1.44 2a9.28 9.28 0 0 0 0 2.21c.09 2 .1 2.13.11 2.72s0 .49 0 2.21a14.82 14.82 0 0 0 0 2.47c.29 1.24.81 1.21 1.08 2.13a7.37 7.37 0 0 0 1.15.26L64 64a7.77 7.77 0 0 1-.19-1.89c.07-.85.3-1 .4-1.75a6.15 6.15 0 0 0-.37-2.66c-.35-1.27-.52-1.19-.9-2.54-.54-2-.29-2.48-.11-2.72s.56-.36.65-.72c.2-.61.11-1.6-.35-1.57z",
    style: {
      fill: "#88909f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5765"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2555",
    cx: 8.18,
    cy: 8.18,
    r: 8.18,
    transform: "translate(62.92 71.74)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21858",
    d: "m77.42 83.09-3.31-.26-4.36 1.07s-1.46 1-2.11 1.45c-.48.29-1.32.76-1.61 1a9.429 9.429 0 0 0 1.77 1.05 8.17 8.17 0 0 0 10.77-4.13 9 9 0 0 0-1.15-.18z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21859",
    d: "M72.69 85.61a3 3 0 0 0 1.69-.92 3.1 3.1 0 0 0 .74-1.78l-1-.08-4.37 1.07-.49.35a3.1 3.1 0 0 0 1.67 1.28 3.37 3.37 0 0 0 1.76.08z",
    style: {
      opacity: 0.52,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21860",
    d: "M69.36 81s1 2.58.42 2.87c-.21.1.37.79 1 1.09a2.76 2.76 0 0 0 3.22-.68 2.53 2.53 0 0 0 .53-1.43l-.22-.06a.45.45 0 0 1-.31-.34l-.57-2.8z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21861",
    d: "m74 82.45-.57-2.8L69.49 81l-.08.16c.07.18.2.54.32.95a18.86 18.86 0 0 0 2.94 1.73c.33 0 .56-.61.66-.86a4.589 4.589 0 0 0 .2-.81 5.7 5.7 0 0 1-.15 2.69 2.24 2.24 0 0 0 .61-.54 2.53 2.53 0 0 0 .53-1.43l-.22-.06a.45.45 0 0 1-.3-.38z",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5764"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21862",
    d: "M73.35 78.06c0-.12.06-.86.29-.89s.4.3.48.59 0 .26 0 .76a2 2 0 0 1 0 .52c-.05.27-.24.59-.41.58s-.41-.87-.36-1.56z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21863",
    d: "M68.77 79c-.08-.09-.6-.64-.83-.51s-.12.42-.09.57a2.15 2.15 0 0 0 .35.7c.23.38.16.43.28.55.27.27.81.37 1 .18s-.29-1.06-.71-1.49z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21864",
    d: "M68.67 79.34a6.57 6.57 0 0 1-.76-1.34 8.65 8.65 0 0 1-.43-2 3 3 0 0 1 1.27-1.84 2.76 2.76 0 0 1 1.76-.43 3.93 3.93 0 0 1 2.24 1c.43.47.91 3.47.91 3.47z",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21865",
    d: "M68.4 76.49c-.06.31.12.45.16 1.42v.91a6.46 6.46 0 0 0 .38 1.4 3.994 3.994 0 0 0 .51 1.18 3 3 0 0 0 1 .76 3.83 3.83 0 0 0 .94.45 2 2 0 0 0 1.44-.4 2.41 2.41 0 0 0 .73-1.09 3.8 3.8 0 0 0 .24-1.26 5.3 5.3 0 0 0-.37-2.23c-.1-.25-.09-.15-.52-1a7 7 0 0 0-.56-1.13c-.8-.93-3.73-.13-3.95.99z",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21866",
    d: "M73.84 79.86a5.35 5.35 0 0 0-.18-1.69v.94a5.53 5.53 0 0 1-.35 1.74 3 3 0 0 1-.51.86 1.52 1.52 0 0 1-1.33.43A1.61 1.61 0 0 1 71 82a1.66 1.66 0 0 1-.3-.19 7.37 7.37 0 0 1-1.36-1.23 4.14 4.14 0 0 1-.75-1.51 10.23 10.23 0 0 0 .41 1.15 3.994 3.994 0 0 0 .51 1.18 3 3 0 0 0 1 .76 3.83 3.83 0 0 0 .94.45 2 2 0 0 0 1.44-.4 2.41 2.41 0 0 0 .73-1.09 3.8 3.8 0 0 0 .22-1.26z",
    style: {
      fill: "#b9bfcc"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21867",
    d: "m117.9 104.58 23.22-23.22-.21-73.85a7 7 0 0 0-7-7H74.76a7 7 0 0 0-7 7v90.07a7 7 0 0 0 7 7z",
    style: {
      fill: "#eef2f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21868",
    d: "M123.65 80.55h17.47l-23.22 23.21V86.29a5.75 5.75 0 0 1 5.75-5.74z",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2556",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.31 15.75)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2557",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.31 43.36)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2558",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.31 70.98)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 80",
    transform: "translate(98.33 29.72)",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      stroke: "#b9bfcc",
      strokeWidth: "2.181px",
      strokeDasharray: "23.265 2.908 .727 3.635",
      fill: "#fff"
    },
    d: "M0 0h36.35"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4829",
    width: 6.11,
    height: 6.11,
    rx: 1.44,
    transform: "translate(98.33 20.16)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 81",
    transform: "translate(98.33 56.62)",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      stroke: "#b9bfcc",
      strokeWidth: "2.181px",
      strokeDasharray: "23.265 2.908 .727 3.635",
      fill: "#fff"
    },
    d: "M0 0h36.35"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4830",
    width: 6.11,
    height: 6.11,
    rx: 1.44,
    transform: "translate(98.33 47.05)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 82",
    transform: "translate(98.33 84.95)",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      stroke: "#b9bfcc",
      strokeWidth: "2.181px",
      strokeDasharray: "23.265 2.908 .727 3.635",
      fill: "#fff"
    },
    d: "M0 0h36.35"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4831",
    width: 6.11,
    height: 6.11,
    rx: 1.44,
    transform: "translate(98.33 75.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21869",
    d: "M109.36 17.36 102.68 24a1.08 1.08 0 0 1-1.49 0l-3.94-3.76a1.08 1.08 0 0 1 1.49-1.55l3.17 3.05 6-5.88a1.079 1.079 0 0 1 1.52 1.53z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5767"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2559",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.31 15.54)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21870",
    d: "M91 31.21a13 13 0 0 0-.2-1.82 3.45 3.45 0 0 1 0-1.71 5.3 5.3 0 0 0-1.8-.52c-1.28-.19-6.07-1.1-6.34-1.18a8.87 8.87 0 0 0-1.87.5l-2.85.25s.28 3.55.33 4.74A9.17 9.17 0 0 0 91 31.21z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21871",
    d: "M85.94 18.28h-.86a4.42 4.42 0 0 0-.65 0 2.09 2.09 0 0 0-1.3.86 3.31 3.31 0 0 0-.64 1.51 5.08 5.08 0 0 0 0 2.16h-.41V20a2.84 2.84 0 0 1 .54-1.18c.55-.68 1.35-1 1.3-1.09s-.43 0-.43 0a3.33 3.33 0 0 1 1.94-.43A3.7 3.7 0 0 1 88 18.82a4.11 4.11 0 0 1 .55 1 1.61 1.61 0 0 1 .1.53v2.56h-.42c-.06-1.19 0-2 0-2.59 0-.09-.31.19-.32.11a2.46 2.46 0 0 0-1.97-2.15z",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21872",
    d: "M87.67 22.81a1.11 1.11 0 0 1 .87-.43c.07 0 .35 0 .43.22s-.2.38-.22.86c0 .23.06.27 0 .44a.7.7 0 0 1-.43.43.8.8 0 0 1-.86-.43 1.1 1.1 0 0 1 .21-1.09z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21873",
    d: "M82.59 23.57c-.07.66-.15 1.24-.21 1.73a3.17 3.17 0 0 1-.22.86 2.82 2.82 0 0 1-.22.44 2.55 2.55 0 0 0 0 1.73 3.66 3.66 0 0 0 2.17 2.16 2.32 2.32 0 0 0 1.51.21c1.15-.32 1.73-1.87 2.16-3 .1-.27.17-.5.22-.65V22.1z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21874",
    d: "M87.78 27.68c.09-.24.16-.45.2-.59a18.91 18.91 0 0 0 0-3.68v-1.14c-.45-.1-2.14 3.82-2.81 5.19a1.94 1.94 0 0 1-.44.65c-.14.13-.21.14-.21.22 0 .23.66.29 1.08.86a1.6 1.6 0 0 1 .22.43 1.5 1.5 0 0 1-.16 1.06c1.13-.35 1.7-1.87 2.12-3z",
    style: {
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21875",
    d: "M83.78 18.28A3.06 3.06 0 0 0 82.49 20a7.41 7.41 0 0 0-.22 2c-.1 1.93 0 2.27.11 2.49a3.017 3.017 0 0 0 3.46 1.72 3.09 3.09 0 0 0 1.94-1.51 6.06 6.06 0 0 0 .43-2.38 5.48 5.48 0 0 0 0-1.94 3.48 3.48 0 0 0-1.51-1.95 3.21 3.21 0 0 0-2.92-.15z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21876",
    d: "M87.78 24.65a5.25 5.25 0 0 0 .41-2.14c-.1.19-.21 2-1.27 2.57a2.16 2.16 0 0 1-.87.22c-.52 0-.64-.24-1.08-.22s-.62.43-1.08.44c-.71 0-1.22-.93-1.3-.87s0 .18.15.4a3.07 3.07 0 0 0 .72.68 3 3 0 0 0 2.38.43 3.09 3.09 0 0 0 1.94-1.51z",
    style: {
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21877",
    d: "M82.49 22.38c-.1-.19-.29-.46-.44-.43s-.16.3-.21.65a1.78 1.78 0 0 0 0 .86c.06.21.24.67.43.65a1.647 1.647 0 0 0 .22-1.73z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21878",
    d: "m92.71 28.85-.28-.2a6.42 6.42 0 0 0-2-1.08c-.79.19-.67 2.59-.26 4.35a9.39 9.39 0 0 0 2.54-3.07z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21879",
    d: "m92.71 28.85-.28-.2a6.42 6.42 0 0 0-2-1.08c-.79.19-.67 2.59-.26 4.35a9.39 9.39 0 0 0 2.54-3.07z",
    style: {
      opacity: 0.78,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21880",
    d: "M78 26.71c-.21 0-.58.34-1.3 1.08l-.58.6A9.24 9.24 0 0 0 78.93 32c.53-2.51-.16-5.18-.93-5.29z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21881",
    d: "M78 26.71c-.21 0-.58.34-1.3 1.08l-.58.6A9.24 9.24 0 0 0 78.93 32c.53-2.51-.16-5.18-.93-5.29z",
    style: {
      opacity: 0.78,
      fill: "#343a5c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5768"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2560",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.27 43.4)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21882",
    d: "M90 56.7c-1.85.22-2.29-.48-3 0s-.46 1.18-1.2 1.5a1.71 1.71 0 0 1-1.2 0c-1-.36-1.2-.9-1.8-1.8-.26-.39-.45 0-2.41.3-1.07.14-.8 2.65-.52 3.86a9.2 9.2 0 0 0 10.39-.87c.14-1.52.12-3.03-.26-2.99z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21883",
    d: "M83.43 52.49c-.4.54.33 1.22 0 2.71a4.9 4.9 0 0 0-.3 1.2 2.69 2.69 0 0 0 .6 1.8c.14.17.92 1.11 1.8.9a1.966 1.966 0 0 0 1.2-2.1c-.06-.8-.42-.74-.6-1.5-.3-1.34.67-2 .3-2.71s-2.43-1.02-3-.3z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21884",
    d: "M86.43 52.79a2.244 2.244 0 0 0-3-.3c-.37.5.23 1.12 0 2.39a5.77 5.77 0 0 0 1.15.32 4.33 4.33 0 0 0 1.46 0c-.04-1.14.73-1.76.39-2.41z",
    style: {
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21885",
    d: "M80.72 59.4c.63-.66 1.14-1.16 1.51-1.5a8.441 8.441 0 0 0 .6-.6 4.75 4.75 0 0 0 .9-1.5 6.32 6.32 0 0 0-1.5-4.51 1.35 1.35 0 0 1-.31-1.2c.08 0-.14 1.78-1.2 9.31z",
    style: {
      fill: "#242b47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21886",
    d: "M90.94 57.3c-.36-.94-.85-.77-1.5-1.8-.92-1.46-.4-2.52-1.2-3a1.86 1.86 0 0 0-2.11.3c-.62.65 0 1.34 0 4.21 0 1.25-.13 1.82.3 2.4s.82.52 1.21 1.21a3.34 3.34 0 0 1 .23.51 9.18 9.18 0 0 0 3.26-2.22 3.42 3.42 0 0 0-.19-1.61z",
    style: {
      fill: "#242b47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21887",
    d: "M82.53 48.28a3.24 3.24 0 0 0-.3 1.2 6.591 6.591 0 0 0 0 .91 11.912 11.912 0 0 0 0 1.5 4.12 4.12 0 0 0 .9 1.5 3.41 3.41 0 0 0 1.2 1.2 1.65 1.65 0 0 0 1.2 0 1.87 1.87 0 0 0 .9-.9 7 7 0 0 0 .91-3.3c0-1.23 0-2.32-.91-3a2.62 2.62 0 0 0-2.7-.3 2.59 2.59 0 0 0-1.2 1.19z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21888",
    d: "M88.84 54.29a26.91 26.91 0 0 0-.6-4.5c-.43-1.93-.66-2.91-1.51-3.61s-2.51-1.17-3-.6a1.49 1.49 0 0 0 .3 1.8c.58.54 1.29.09 1.8.6.33.32.2.65.3 2.11s.17 2.18.6 2.7.92.37 1.21.9-.14 1.2-.3 2.71a6.28 6.28 0 0 0 0 1.8A4.76 4.76 0 0 0 89 60.58a9.818 9.818 0 0 0 1-.67c-.32-1-.57-1.11-.87-2-.39-1.2-.21-1.75-.29-3.62z",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21889",
    d: "M92.13 57.64A1.69 1.69 0 0 0 90.8 57h-1.06v3.11a9.21 9.21 0 0 0 2.39-2.47z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21890",
    d: "m78 58-.43.64a9.33 9.33 0 0 0 3 2.23l.56-4h-1A2.54 2.54 0 0 0 78 58z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21891",
    d: "M83.73 45.58c-.65-.11-2 1.46-2.11 1.8a10.46 10.46 0 0 0-.6 2.41c-.43 2.2-.45 2.35-.6 3s-.13.53-.6 2.41a15.29 15.29 0 0 0-.6 2.7c0 1.43.55 1.54.6 2.62a8.72 8.72 0 0 0 1.18.58 1.151 1.151 0 0 0 0-.19 8.72 8.72 0 0 1 .3-2.11c.31-.92.59-1 .91-1.8a7 7 0 0 0 .3-3c0-1.47-.25-1.43-.3-3-.08-2.28.34-2.79.6-3s.7-.24.9-.6c.36-.63.53-1.74.02-1.82z",
    style: {
      fill: "#343a5c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5770"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2561",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(75.31 70.98)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21892",
    d: "M90.54 85.31 87 84.15h-5s-1.87.75-2.69 1c-.6.19-1.64.47-2 .65a10.54 10.54 0 0 0 1.64 1.63 9.19 9.19 0 0 0 12.84-1.64 8.56 8.56 0 0 0-1.25-.48z",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21893",
    d: "M84.71 86.79a3.39 3.39 0 0 0 2.09-.55 3.45 3.45 0 0 0 1.28-1.74L87 84.15h-5l-.63.25a3.5 3.5 0 0 0 1.48 1.84 3.66 3.66 0 0 0 1.86.55z",
    style: {
      opacity: 0.52,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21894",
    d: "M82.31 80.89s.45 3.11-.31 3.24c-.25.05.2 1 .77 1.45a3.14 3.14 0 0 0 3.73.12 3 3 0 0 0 1-1.42l-.23-.13a.51.51 0 0 1-.25-.46l.12-3.2z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21895",
    d: "m87 83.69.12-3.2-4.63.39-.13.15c0 .21.08.64.1 1.12a20.85 20.85 0 0 0 2.74 2.67c.37.05.78-.52 1-.76a4.92 4.92 0 0 0 .43-.84 6.29 6.29 0 0 1-.87 2.9 2.61 2.61 0 0 0 .81-.42 3 3 0 0 0 1-1.42l-.23-.13a.51.51 0 0 1-.34-.46z",
    style: {
      opacity: 0.47,
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5769"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21896",
    d: "M87.44 78.74c0-.13.29-.92.56-.9s.36.44.36.78-.08.28-.18.83a2.76 2.76 0 0 1-.12.57c-.13.28-.43.58-.61.52s-.25-1.06-.01-1.8z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21897",
    d: "M82.2 78.53c-.06-.11-.48-.85-.77-.77s-.25.42-.26.6a2.46 2.46 0 0 0 .21.85c.14.48.06.51.15.67.22.37.78.63 1 .46s.01-1.21-.33-1.81z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21898",
    d: "M82 78.89a7.42 7.42 0 0 1-.46-1.68 9.68 9.68 0 0 1 .07-2.35 3.46 3.46 0 0 1 1.88-1.67 3.11 3.11 0 0 1 2 0 4.36 4.36 0 0 1 2.16 1.73c.35.62.07 4 .07 4z",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21899",
    d: "M82.46 75.7c-.15.32 0 .53-.21 1.6-.11.57-.17.58-.23 1a6.92 6.92 0 0 0 0 1.62c.11 1.21.17 1.26.25 1.43a3.51 3.51 0 0 0 .92 1.1 3.9 3.9 0 0 0 .91.74 2.13 2.13 0 0 0 1.68-.06 2.63 2.63 0 0 0 1.08-1 4.3 4.3 0 0 0 .6-1.31 5.87 5.87 0 0 0 .19-2.53 8.754 8.754 0 0 0-.29-1.27 9.1 9.1 0 0 0-.31-1.39c-.64-1.18-4.05-1.09-4.59.07z",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21900",
    d: "M87.5 80.83a6.26 6.26 0 0 0 .25-1.89c-.07.31-.15.67-.26 1a6.2 6.2 0 0 1-.85 1.81 3.8 3.8 0 0 1-.78.81 1.75 1.75 0 0 1-1.56.11 2.5 2.5 0 0 1-.46-.29 2.42 2.42 0 0 1-.27-.28 8.42 8.42 0 0 1-1.16-1.71 4.45 4.45 0 0 1-.41-1.83 11.919 11.919 0 0 0 .06 1.36c.11 1.21.17 1.26.25 1.43a3.51 3.51 0 0 0 .92 1.1 3.9 3.9 0 0 0 .91.74 2.13 2.13 0 0 0 1.68-.06 2.63 2.63 0 0 0 1.08-1 4.3 4.3 0 0 0 .6-1.3z",
    style: {
      fill: "#b8a4d5"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21901",
    d: "m117.9 104.58 23.22-23.22-.21-73.85a7 7 0 0 0-7-7H74.76a7 7 0 0 0-7 7v90.07a7 7 0 0 0 7 7z",
    style: {
      stroke: "#753bba",
      strokeWidth: "1.062px",
      strokeDasharray: "35.408 1.416 1.416 2.833 8.498 .708",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21902",
    d: "M117.9 103.76V86.29a5.75 5.75 0 0 1 5.75-5.74h17.47",
    style: {
      stroke: "#753bba",
      strokeWidth: "1.062px",
      strokeDasharray: "35.408 1.416 1.416 2.833 8.498 .708",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAddAccount);
export default __webpack_public_path__ + "static/media/success-add-account.364511bc40dade334e0eb8ce3ad71576.svg";
export { ForwardRef as ReactComponent };